import { render, staticRenderFns } from "./blueprint-update.vue?vue&type=template&id=c807f90a&scoped=true&"
import script from "./blueprint-update.vue?vue&type=script&lang=ts&"
export * from "./blueprint-update.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c807f90a",
  null
  
)

export default component.exports